import * as React from 'react';
import { AnyAction, Dispatch } from 'redux';

import { GetAllEventsStatisticsRequest } from '../api/definitions/getAllEventsStatisticsRequest';
import { GetIndividualEventsStatisticsRequest } from '../api/definitions/getIndividualEventsStatisticsRequest';
import * as EntityNormalizers from '../api/normalizers/entityNormalizers';
import { NormalizedEventStatistics } from '../api/normalizers/eventStatisticsNormalizers';
import { DataRequestActionTypes, InternalActionTypes } from '../constants/actionTypes';

import { RequestAction } from './allActions';
import { runApiRequest, throttleRequests } from './saga/sagaActions';

export interface EventStatisticsLoadedAction extends AnyAction {
  result: EntityNormalizers.NormalizedEntityArray<NormalizedEventStatistics>;
  type: InternalActionTypes.EventStatisticsLoaded;
}

export interface RequestEventStatisticsAction extends RequestAction {
  type: DataRequestActionTypes.EventsStatisticsRequested;
  eventIds?: string[];
}

export function createEventsStatisticsRequestedAction(
  eventIds: string[],
  component: React.Component,
  dispatch: Dispatch,
): RequestEventStatisticsAction {
  return {
    dispatch,
    eventIds,
    requestingComponent: component,
    type: DataRequestActionTypes.EventsStatisticsRequested,
  };
}

export function createEventStatisticsLoaded(
  result: EntityNormalizers.NormalizedEntityArray<NormalizedEventStatistics>,
): EventStatisticsLoadedAction {
  return {
    result,
    type: InternalActionTypes.EventStatisticsLoaded,
  };
}

function* loadEventsStatistics(action: RequestEventStatisticsAction) {
  // We cannot request statistics for more than 500 events at one time
  if (action.eventIds) {
    const request = new GetIndividualEventsStatisticsRequest(
      action.eventIds,
      action.requestingComponent,
      action.dispatch,
    );
    // @ts-ignore
    yield runApiRequest(request, createEventStatisticsLoaded);
  } else {
    const request = new GetAllEventsStatisticsRequest(action.requestingComponent, action.dispatch);
    // @ts-ignore
    yield runApiRequest(request, createEventStatisticsLoaded);
  }
}

export function* loadEventStatisticsSaga() {
  yield throttleRequests(DataRequestActionTypes.EventsStatisticsRequested, loadEventsStatistics, action =>
    action.eventIds ? action.eventIds.join(',') : 'all',
  );
}
